const Airport = ({ className = "", color }: { className?: string; color: string }): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer1"
      d="M49.265 50.709L45.95 25.12l10.607-10.606a5 5 0 0 0-7.07-7.071L38.879 18.049l-25.586-3.31s-1.878-.337-2.7.482L7.617 18.2a1.346 1.346 0 0 0-.383 1.4c.153.51 1.581 1.173 2.041 1.378s17.7 8.976 17.7 8.976l-7.185 7.185-.71.709s-8.13-1.172-9.074-1.3a1.641 1.641 0 0 0-1.463.526l-2.189 2.189c-.255.255-.887.978.44 1.59s11.58 4.772 11.58 4.772 4.161 10.255 4.773 11.582 1.335.7 1.59.44l2.188-2.19a1.644 1.644 0 0 0 .524-1.464c-.127-.943-1.3-9.074-1.3-9.074l.71-.71 7.181-7.181s8.774 17.239 8.978 17.7.868 1.888 1.378 2.041a1.347 1.347 0 0 0 1.4-.385l2.983-2.984c.821-.815.486-2.691.486-2.691z"
      fill={color}
    ></path>
    <path
      data-name="opacity"
      d="M56.462 7.365a4.993 4.993 0 0 0-6.976.077L38.879 18.049l-25.586-3.31s-1.878-.337-2.7.482L7.617 18.2a1.346 1.346 0 0 0-.383 1.4c.153.51 1.581 1.173 2.041 1.378s17.7 8.976 17.7 8.976l-7.185 7.185-.71.709s-8.13-1.172-9.074-1.3a1.641 1.641 0 0 0-1.463.526l-2.189 2.189c-.255.255-.887.978.44 1.59 1.242.572 10.3 4.252 11.457 4.722z"
      fill="#000064"
      opacity=".15"
    ></path>
  </svg>
);

export default Airport;
